export default {
  startDate: 'Start date',
  endDate: 'End date',
  submitFilter: 'Submit',
  chart: {
    title: 'MBD Completed Projects based on the selected dates',
  },
};
